import IntroPc1 from '@/assets/images/intro/intro-pc-1.png';
import IntroPcGradient from '@/assets/images/intro/intro-pc-gradient.png';
import IntroMobile1 from '@/assets/images/intro/intro-mobile-1.png';
import SellerboxBoxLogoUrl from '@/assets/icons/sellerbox-box-logo.svg';

export const APP_STORE_URL =
  'https://apps.apple.com/kr/app/%EC%85%80%EB%9F%AC%EB%B0%95%EC%8A%A4-%EC%98%A8%EB%9D%BC%EC%9D%B8-%ED%8C%90%EB%A7%A4%EC%9E%90-%EB%A7%88%EC%BC%93-%EB%8D%B0%EC%9D%B4%ED%84%B0-%ED%86%B5%ED%95%A9-%EA%B4%80%EB%A6%AC-%EC%95%B1/id1590729784';
export const GOOGLE_PLAY_URL =
  'https://play.google.com/store/apps/details?id=com.circleplatform.sellerbox';

export const IntroPage = () => {
  return (
    <div className="min-h-screen  bg-gr-100">
      <div className="flex h-full flex-col items-center  px-[50px] pb-[120px] pt-[190px] max-md:hidden">
        <div className="flex flex-col items-center gap-6">
          <img src={SellerboxBoxLogoUrl} />
          <div className="text-[50px] font-semibold text-gr-900">
            셀러박스 사용이 시작되었습니다.
          </div>
          <div className="text-2xl text-gr-700">
            셀러박스에서 커머스 솔루션 데이터를 확인해 보세요!
          </div>
          <button
            className="flex h-12 shrink-0 items-center justify-center rounded-[30px] bg-gr-800 px-[30px] text-white Body1S16"
            onClick={() => window.open('https://app.sellerbox.io/')}
          >
            셀러박스 웹
          </button>
        </div>
        <div className="relative z-10">
          <img src={IntroPcGradient} className="absolute top-[132px] -z-10" />
          <div className="px-[150px]">
            <img src={IntroPc1} className="z-20 object-contain" />
          </div>
        </div>
      </div>
      <div className="flex h-full flex-col items-center overflow-hidden px-8 py-[60px] md:hidden">
        <div className="flex flex-col items-center gap-3">
          <img src={SellerboxBoxLogoUrl} className="w-14" />
          <div className="text-[20px] font-semibold text-gr-900">셀러박스 사용이 시작되었어요</div>
          <div className="text-sm text-gr-700">셀러박스에서 데이터를 확인해보세요!</div>
          <div className="flex items-center gap-3 ">
            <button
              className="flex h-11 items-center gap-3 rounded-sm bg-white px-5 text-sm"
              onClick={() => window.open(APP_STORE_URL)}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.7705 21.4634C16.6505 22.5491 15.4276 22.3777 14.2505 21.8634C13.0048 21.3377 11.8619 21.3148 10.5476 21.8634C8.90193 22.572 8.03336 22.3663 7.0505 21.4634C1.47336 15.7148 2.29621 6.96056 8.62764 6.64056C10.1705 6.72056 11.2448 7.48627 12.1476 7.55484C13.4962 7.28056 14.7876 6.49199 16.2276 6.59484C17.9534 6.73199 19.2562 7.4177 20.1134 8.65199C16.5476 10.7891 17.3934 15.4863 20.6619 16.8006C20.0105 18.5148 19.1648 20.2177 17.7591 21.4748L17.7705 21.4634ZM12.0334 6.57199C11.8619 4.02342 13.9305 1.92056 16.3076 1.71484C16.6391 4.66341 13.6334 6.8577 12.0334 6.57199Z"
                  fill="black"
                />
              </svg>
              App Store
            </button>
            <button
              className="flex h-11 items-center gap-1 rounded-sm bg-white px-5 text-sm"
              onClick={() => window.open(GOOGLE_PLAY_URL)}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_19249_34046)">
                  <path
                    d="M16.1157 14.5215C18.1127 13.4482 19.6266 12.6304 19.7571 12.5668C20.1746 12.3496 20.6056 11.7745 19.7571 11.3278C19.4832 11.1873 18.0081 10.3949 16.1157 9.37305L13.4922 11.9664L16.1157 14.5215V14.5215Z"
                    fill="#FFD900"
                  />
                  <path
                    d="M13.4941 11.9668L5.14062 20.2073C5.3367 20.2328 5.55806 20.1819 5.81904 20.0414C6.36697 19.7479 12.1755 16.643 16.1176 14.5225L13.4941 11.9668Z"
                    fill="#F43249"
                  />
                  <path
                    d="M13.4914 11.9665L16.1149 9.38595C16.1149 9.38595 6.40395 4.19862 5.8164 3.89241C5.59504 3.76408 5.34698 3.72596 5.125 3.76408L13.4914 11.9665Z"
                    fill="#00EE76"
                  />
                  <path
                    d="M13.4929 11.9661L5.12649 3.76367C4.78695 3.84051 4.5 4.13414 4.5 4.73464V19.2357C4.5 19.7853 4.72204 20.1812 5.13947 20.2193L13.4929 11.9661Z"
                    fill="#00D3FF"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_19249_34046">
                    <rect
                      width="15.75"
                      height="16.5"
                      fill="white"
                      transform="translate(4.5 3.75)"
                    />
                  </clipPath>
                </defs>
              </svg>
              Google Play
            </button>
          </div>
          <div className="text-sm text-gr-700">무료로 시작하세요!</div>
        </div>
        <div className="relative z-10">
          <img src={IntroMobile1} className="z-20" />
          <img
            src={IntroPcGradient}
            className="absolute -bottom-10 left-1/2 -z-10 min-w-[820px] -translate-x-1/2"
          />
        </div>
      </div>
    </div>
  );
};
